export default "__VITE_ASSET__CzKX6JC3__"